<template>
  <section class="check_notice">
    <help-center-bar class="tab"></help-center-bar>
    <div class="container">
      <div class="helpCenter">
          <s-title-header :mainTitle='docTitle' subTitle="帮助手册" :description="titleDes"></s-title-header>
      </div>
      <div class="content_area">
        <!-- 左侧编辑框 -->
        <div class="edit_content doc_edit">
          <div id="main">
            <mavon-editor ref='md' @imgAdd="$imgAdd" :toolbars="toolbars" v-model="contentText" @change="changeText"/>
          </div>
        </div>
        <!-- 右侧设置框 -->
        <div class="btn_right">
          <span class="save">
            <s-button @click.native="saveEdit" width=0.68 height=0.2 color="#fff" ave="#276BEE" textWord="保存" lineheight=0.2></s-button>
          </span>
          <span class="cancel">
            <s-button @click.native="cancelEdit" width=0.68 height=0.2 color="#276BEE" ave="#fff" textWord="取消" lineheight=0.2></s-button>
          </span>
        </div>
      </div>
    </div>

  </section>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import $ from 'jquery'
import Api from '@/api/api'
import HelpCenterBar from '@/components/HelpCenterBar'
import STitleHeader from '@/components/STitleHeader'
import SButton from '@/components/SButton'
const qiniu = require('qiniu-js')
export default {
  /******************************************
  ** 组件名称
  * @description 组件描述
  * @author ah
  *****************************************
  prop1          <type>            <属性描述>
  *****************************************/
  name: 'CheckNotice',
  components: {HelpCenterBar, SButton, STitleHeader},
  props: {
  },
  data () {
    return {
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        // underline: true, // 下划线
        // strikethrough: true, // 中划线
        // mark: true, // 标记
        // superscript: true, // 上角标
        // subscript: true, // 下角标
        // quote: true, // 引用
        // ol: true, // 有序列表
        // ul: true, // 无序列表
        // link: true, // 链接
        imagelink: true, // 图片链接
        // code: true, // code
        // table: true, // 表格
        // fullscreen: true, // 全屏编辑
        // readmodel: true, // 沉浸式阅读
        // htmlcode: true, // 展示html源码
        // help: true, // 帮助
        // /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        // trash: true, // 清空
        // save: true, // 保存（触发events中的save事件）
        // /* 1.4.2 */
        navigation: true, // 导航目录
        // /* 2.1.8 */
        // alignleft: true, // 左对齐
        // aligncenter: true, // 居中
        // alignright: true, // 右对齐
        // /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true // 预览
      },
      contentText: '',
      upValue: '',
      upRender: '',
      docTitle: '',
      titleDes: ''
    }
  },
  computed: {},
  created () {
    // 获取文档管理的信息,展示在编辑器中
    // console.log(this.$route.params.id)
    // axios.get('http://192.168.1.161:7001/api/documents/' + this.$route.params.id).then(res => {
    //   if (res.status === 200) {
    //     console.log(res.data)
    //     console.log(res.data.Result[0].MdContents)
    //     this.contentText = res.data.Result[0].MdContents
    //     this.docTitle = res.data.Result[0].Name
    //     this.titleDes = res.data.Result[0].Description
    //   }
    // })
    this.CnInfo()
    this.scroll()
  },
  methods: {
    // 图片添加回调事件
    $imgAdd (pos, $file) {
      let token = ''
      // 上传图片到七牛
      // 1.获取七牛token
      axios
        .post(
          'https://liveclientapiv2.aiyaopai.com',
          qs.stringify({
            api: 'Storage.GetUserToken'
          }),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        )
        .then(res => {
          token = res.data.Token
          // 2.上传图片
          let next = (response) => {
            let total = response.total
            this.process = total.percent + '%'
          }
          let error = (response) => {
            // console.log('======error', response)
          }
          let putExtra = {
            fname: '',
            params: {},
            mimeType: null
          }
          let config = {
            useCdnDomain: true,
            region: qiniu.region.z0
          }
          let complete = (response) => {
            // 将图片url传入
            this.$refs.md.$img2Url(pos, response.url)
          }
          let observable = qiniu.upload($file, $file.name, token, putExtra, config)
          observable.subscribe(next, error, complete)
        })
    },
    // 滚动一定高度固定
    scroll () {
      // 滑动到一定高度,固定tab栏
      $(window).scroll(function () {
        let scrollDistance = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // console.log(scrollDistance)
        if (scrollDistance >= 0) {
          $('.tab').addClass('fixnav')
        } else {
          $('.tab').removeClass('fixnav')
        }
        if (scrollDistance >= 226) {
          $('.btn_right').addClass('fixbtn')
        } else {
          $('.btn_right').removeClass('fixbtn')
        }
        if (scrollDistance >= 226) {
          // $('.v-note-wrapper .v-note-op.shadow ').addClass('fixop')
          // $('.v-note-wrapper .v-note-op.shadow ').css('width', '900px')
        } else {
          // $('.v-note-wrapper .v-note-op.shadow ').removeClass('fixop')
        }
      }
      )
    },
    // 获取文档管理的信息,展示在编辑器中
    CnInfo () {
      Api.getDoc(this.$route.params.id).then(res => {
        if (res.status === 200) {
          // console.log(res.data)
          // console.log(res.data.Result[0].MdContents)
          this.contentText = res.data.Result[0].MdContents
          this.docTitle = res.data.Result[0].Name
          this.titleDes = res.data.Result[0].Description
        }
      })
        .catch(err => {
          console.log(err)
        })
    },
    changeText (value, render) {
      // console.log(value)
      // console.log(render)
      this.upValue = value
      this.upRender = render
    },
    // 点击保存按钮,保存文档修改
    saveEdit () {
      // console.log(this.$route.params.id)
      Api.saveChange(this.upRender, this.upValue, this.$route.params.id).then(res => {
        if (res.status === 200) {
          // console.log(this.$route)
          this.$router.push({
            name: 'DocManage',
            params: {
              id: this.$route.params.id
            }
          })
        }
      })
        .catch(err => {
          console.log(err)
        })
    },
    cancelEdit () {
      this.$router.push({
        name: 'DocManage',
        params: {
          id: this.$route.params.id
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.check_notice{
  /* tab栏固定效果 */
   .fixnav {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index:9999;
    background-color: #F7F7F7;
  }
  .container {
      // width: 1080px;
      width: 88%;
      margin:0 auto;
      // height: 500px;
      height:2.5rem;
      .helpCenter{
        // padding:80px 0 0 0;
        // width: 100%;
        // height: 200px;
        // display:flex;
        // justify-content: space-between;
        padding:0.4rem 0;
        padding-top:0.6rem;
        width: 100%;
        height: auto;
        line-height: auto;
        display: flex;
        justify-content: space-between;
      }
      .content_area{
        width: 100%;
        padding-right:0.2rem;
        // display: flex;
        // justify-content: space-between;
        box-sizing: border-box;
        .edit_content{
          // width:790px;
          width: 86%;
          height: 1000px;
          float:left;
        }
        #main{
          width:90%;
        }
        .btn_right{
          float:right;
          width: 10%;
          .cancel,.save{
            margin-bottom:20px;
            display: block;
          }

        }
        // .fixbtn{
        //   position: fixed;
        //   top: 53px;
        //   left: 1358px;
        //   background-color: #fff;
        //   z-index:2000;
        // }

      }
    }
   .v-note-op .shadow{
        width:800px !important;
      }
  .fixop{
    left:0;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/CheckNotice.vue